const TestBackendResponseTypes = {
  TEACHER_WILL_EVALUATE: 'you have attempted this Test Teacher will evaluate',
  TEACHER_HAS_EVALUATED: 'you have attempted this Test and your marks are out',
};

export default TestBackendResponseTypes;
